import axios from "@/libs/axios";
import { computed, ref, watch } from "@vue/composition-api";

export default function useChannelsList() {
    const refTable = ref(null);
    const tableColumns = [
        { key: "name", sortable: true },
        { key: "platform", sortable: true },
        { key: "identity", sortable: true },
        { key: "active", sortable: true },
        { key: "actions" },
    ];
    const perPage = ref(10);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("name");
    const isSortDirDesc = ref(false);
    const isLoading = ref(true);

    const dataMeta = computed(() => {
        const localItemsCount = refTable.value ? refTable.value.localItems.length : 0;

        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        };
    });

    const refetchData = () => {
        refTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        if (searchQuery.value.length > 0 && searchQuery.value.length < 2) {
            return;
        }

        refetchData();
    });

    const read = (ctx, callback) => {
        axios
            .get("channels", {
                params: {
                    fields: "name,provider,platform,identity,active",
                    s: {
                        $or: [
                            { name: { $cont: searchQuery.value } },
                            { platform: { $cont: searchQuery.value } },
                            { identity: { $cont: searchQuery.value } },
                        ],
                    },
                    limit: perPage.value,
                    page: currentPage.value,
                    sort: `${sortBy.value},${isSortDirDesc.value === true ? "DESC" : "ASC"}`,
                },
            })
            .then((response) => {
                callback(response.data.data);
                total.value = response.data.total;
            })
            .finally(() => (isLoading.value = false));
    };

    return {
        read,
        refetchData,
        tableColumns,
        perPage,
        currentPage,
        total,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTable,
        isLoading,
    };
}
